import { useState } from 'react';
import { api_url, DEFAULT_LOGO_SRC } from "../../constant/constant";
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Forgotpassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${api_url}/password-reset/email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        toast.error(data.message || t('SomethingWentWrong'));
        return;
      }

      if (data.status === 'success') {
        toast.success(t('ResetLinkSent'));
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      } else {
        toast.error(data.message || t('SomethingWentWrong'));
      }
    } catch (err) {
      toast.error(t('ErrorOccurred'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='container' style={{ height: '100vh' }}>
      <div className='row justify-content-center'>
        <div className='col-md-5 mb-5'>
          <div className='loginLogo mt-5' align='center'>
            <img src={DEFAULT_LOGO_SRC} alt='Cyber Sense' style={{width:'160px'}}/>
          </div>
          <div className='card mt-5 pb-5' style={{ borderRadius: '30px' }}>
            <div className='card-body'>
              <h2 className='m-5 txtLoginAccount' align='center'>
                {t('ForgotPassword')}
              </h2>
              <form onSubmit={handleSubmit} className='px-5'>
                <div className='form-group mb-3'>
                  <label htmlFor='email'>{t('EnterYourEmail')}</label>
                  <input
                    type='email'
                    className='form-control mt-2'
                    id='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button type='submit' className='btn btn-dark w-100 p-2' disabled={loading}>
                  {loading ? (
                    <span
                      className='spinner-border spinner-border-sm'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  ) : (
                    t('SendResetLink')
                  )}
                </button>

                <div className='mt-3 text-center mb-3'>
                  <a href='/login' className='text-primary'>
                    {t('Getbacktosignin')}
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forgotpassword;
